import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import * as Styled from './classroom-awaiting.style';

const ClassroomAwaitingResponse = () => (
  <Styled.ClassroomAwaiting
    $gap={8}
    $alignItems="center"
    $flexDirection="column"
  >
    <ActivityBuilderInlineSvg id="icon_clock" width={40} height={40} />
    <span>Awaiting answer</span>
  </Styled.ClassroomAwaiting>
);

export default ClassroomAwaitingResponse;
